// extracted by mini-css-extract-plugin
module.exports = {"root":"item__3j6KlTbU"};